import React from "react";
import Parser from "../../parser";
const Buttons = (props) => {
    return (React.createElement("div", { className: props.attributes.className },
        React.createElement(Parser, { structure: props.innerBlocks })));
};
export default Buttons;
